// @flow
import * as React from 'react';
import { NavLink } from 'react-router';
import classNames from 'classnames';

type Props = {
  className: String,
  [string]: mixed,
};

/**
 * A wrapper around react-router's NavLink to make it work with Semantic UI's Menu.Item
 * react-router v6 has removed activeClassName, and made this possible via setting className
 * to a callback function, however Semantic UI will enforce className to be a string.
 * This is why this component was created.
 */
const MenuItemNavLink = ({ className, ...rest }: Props): React$Node => {
  return (
    <NavLink
      {...rest}
      className={({ isActive }) =>
        classNames(className, 'nav-menu__nav-link', {
          'nav-menu__nav-link--active': isActive,
        })
      }
    />
  );
};

export default MenuItemNavLink;
